import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, MissionPageContainer } from "../../common_components/Layout";
import SubHeader from "../SubHeader";
import Scheduling from "../../create_mission_components/components/Scheduling";

// Api Calls



function SchedulingPage(props) {
    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()

    return (
        <>
            <SubHeader title={"Scheduling"} backText="Back to Project" navigateBack={() => navigate("/missions/" + missionId)} />
            <MissionPageContainer>
                <Scheduling savePath={"/missions/" + missionId} backPath={"/missions/" + missionId} saveText="Save" />
            </MissionPageContainer>
        </>

    )

}

export default SchedulingPage;